// Attach Django's CSRF token as a header on every htmx request.
// Required for DELETE/PUT/PATCH: Django's CsrfViewMiddleware only reads
// the csrfmiddlewaretoken body field for POST, and falls back to the
// X-CSRFToken header for every other unsafe method.
import Cookies from 'js-cookie'

document.body.addEventListener('htmx:config:request', (event) => {
    event.detail.ctx.request.headers['X-CSRFToken'] = Cookies.get('csrftoken')
})
